import React from 'react';
import { instanceOf } from 'prop-types';
import { connect } from 'react-redux';

import IELoading from '../IELoading';
import TCTree from './TCTree';
import TcSelections from './TcSelections';
import EstimatedIR from './EstimatedIR';
import SampleSizes from './SampleSizes';
import EstimatedCost from './EstimatedCost';

const TargettingCriteria = ({
  targetingCriteria,
  selectedTargets,
  ir_ss_data,
}) => {
  if (targetingCriteria.loading) {
    return (
      <div className="ie--card">
        <IELoading />
      </div>
    );
  }
  return (
    <div className="ie--card">
      <div className="ie--card--body">
        <div className="ie--card--col">
          <h2 className="ie--card--title">Target</h2>
          <div className="ie--target--box">
            <TCTree />
          </div>
          <div className="ie--settings--message">
            Select the relevant consumer segment to field your study. Your panel
            will be composed of respondents that match your criteria.
            <br />
            Targets from the same category are grouped using the OR operator and
            targets from multiple categories are grouped using the AND operator.
            <br />
            For example, (AGE: 18 OR AGE: 19) AND GENDER: Female.
          </div>
        </div>
        <div className="ie--card--col">
          <h3 className="ie--card--title">Selection</h3>
          <TcSelections
            selectedTargets={selectedTargets}
            loading={ir_ss_data.loading}
            error={ir_ss_data.error}
          />
          <EstimatedIR />
          <SampleSizes />
        </div>
      </div>
      <EstimatedCost />
    </div>
  );
};

TargettingCriteria.propTypes = {
  targetingCriteria: instanceOf(Object),
  selectedTargets: instanceOf(Array),
  ir_ss_data: instanceOf(Object),
};

TargettingCriteria.defaultProps = {
  selectedTargets: [],
  targetingCriteria: {
    loading: true,
    error: false,
    data: [],
  },
  ir_ss_data: {
    loading: true,
    error: false,
  },
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { targetingCriteria, selectedTargets, ir_ss_data } = turnkeyOmnibus;
  return {
    targetingCriteria,
    selectedTargets,
    ir_ss_data,
  };
};

export default connect(
  mapStateToProps,
  null
)(TargettingCriteria);
